export default "__VITE_ASSET__BL_m$k7N__"